module.exports = __webpack_public_path__ + "img/equipment-sticker-01.75839460.png";